export default "__VITE_ASSET__9c4c7706__"